// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"1ee684b6","167":"c1444825","450":"b08c4dfd","645":"b0292336","672":"530ff8d7","688":"433811ef","711":"f626dfbf","734":"7ba8777a","912":"e82f03e3","921":"dc910497"}[chunkId] + ".chunk.css";
};